import React, { useEffect, useRef, useState } from "react";
import { ViewSelectedCandidateList } from "../../../Redux/action/VendorDashboardAction";
import { GetSelectedPurchaseDetails } from "../../../Redux/action/PurchaseOrderAction";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Modal, Spinner } from "react-bootstrap";
import { Accordion } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import { RiExchangeFill } from "react-icons/ri";
import { ChangeStatusOfPurchaseOrder } from "../../../Services/parchaseOrderServices";
import { ImCancelCircle } from "react-icons/im";
import {
  Box,
  Paper,
  Typography,
  Select,
  MenuItem,
  TextField,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  CircularProgress,
  Stack,
} from "@mui/material";
import { IoSearch, IoEyeSharp } from "react-icons/io5";
import { FiFilter } from "react-icons/fi";
import { BsXCircleFill } from "react-icons/bs";
import { AiOutlineClockCircle } from "react-icons/ai";
import Pagination from "../../Common/Pagination/Pagination";
import { MdOutlineEditNote } from "react-icons/md";
import { Verified } from "@mui/icons-material";
import useDebounce from "../../../Hooks/useDebounce";
import Loader from "../../Common/Loader/loader";

export const PurchaseOrderList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 800);
  const [activeTab, setActiveTab] = useState("ALL");
  const [status, setStatus] = useState("ALL");
  const [pageNumber, setPageNumber] = useState(0);
  const [size] = useState(8);

  const loader = useSelector((state) => state?.PurchaseOrderDetails?.loading);
  const totalPages = useSelector(
    (state) => state?.PurchaseOrderDetails?.result?.totalPages
  );
  const purchase_details = useSelector(
    (state) => state?.PurchaseOrderDetails?.result?.content
  );

  useEffect(() => {
    dispatch(
      GetSelectedPurchaseDetails({
        search,
        size,
        pageNumber,
        activeTab,
        status,
      })
    );
  }, [pageNumber, activeTab, debouncedSearch, status]);

  useEffect(() => {
    setPageNumber(0);
  }, [debouncedSearch, activeTab, status]);

  let lastCandidateId = null;
  let colorToggle = false;

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#f6f9ff", p: 3 }}>
      <Paper sx={{ borderRadius: 3, p: 2 }}>
        {/* Header */}
        <Stack
          mb={2}
          sx={{
            p: 2.5,
            borderRadius: 3,
            border: "1px solid rgba(45, 109, 150, 0.25)",
            background: `
      linear-gradient(
        180deg,
        rgba(45, 109, 150, 0.12) 0%,
        rgba(45, 109, 150, 0.06) 45%,
        #ffffff 100%
      )
    `,
            position: "sticky",
            top: 0,
            zIndex: 10,
            backdropFilter: "blur(6px)",
          }}
        >
          <Stack
            sx={{
              flexBasis: { xs: "100%", sm: "50%", md: "25%" },
              flexShrink: 0,
            }}
          >
            <Typography
              fontWeight={700}
              fontSize={16}
              mb={2}
              sx={{
                color: "#2d6d96",
                whiteSpace: "nowrap",
              }}
            >
              Purchase Order List
            </Typography>
          </Stack>{" "}
          <Stack
            direction="row"
            alignItems="center"
            gap={2}
            flexWrap="wrap"
            sx={{ width: "100%" }}
          >
            {/*  Order Type */}
            <Stack sx={{ flexBasis: { xs: "100%", sm: "50%", md: "25%" } }}>
              <Select
                fullWidth
                size="small"
                value={activeTab}
                onChange={(e) => setActiveTab(e.target.value)}
                startAdornment={
                  <FiFilter size={14} style={{ marginRight: 6 }} />
                }
                sx={{
                  height: 38,
                  borderRadius: 2,
                  minWidth: 180,
                  "& fieldset": { borderColor: "rgba(45,109,150,0.45)" },
                  "&:hover fieldset": { borderColor: "#2d6d96" },
                  "&.Mui-focused fieldset": {
                    borderColor: "#2d6d96",
                    borderWidth: 1.5,
                  },
                }}
              >
                <MenuItem value="ALL">All Orders</MenuItem>
                <MenuItem value="SUPPLIER_ORDER">Supplier Order</MenuItem>
                <MenuItem value="CLIENT_ORDER">Client Order</MenuItem>
                <MenuItem value="CANDIDATE_ORDER">Candidate Order</MenuItem>
              </Select>
            </Stack>

            {/*  Status */}
            <Stack sx={{ flexBasis: { xs: "100%", sm: "50%", md: "25%" } }}>
              <Select
                fullWidth
                size="small"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                startAdornment={
                  <FiFilter size={14} style={{ marginRight: 6 }} />
                }
                sx={{
                  height: 38,
                  borderRadius: 2,
                  minWidth: 160,
                  "& fieldset": { borderColor: "rgba(45,109,150,0.35)" },
                  "&:hover fieldset": { borderColor: "#2d6d96" },
                  "&.Mui-focused fieldset": {
                    borderColor: "#2d6d96",
                    borderWidth: 1.5,
                  },
                }}
              >
                <MenuItem value="ALL">All Status</MenuItem>
                <MenuItem value="PENDING">Pending</MenuItem>
                <MenuItem value="ACCEPTED">Accepted</MenuItem>
                <MenuItem value="REJECTED">Rejected</MenuItem>
              </Select>
            </Stack>

            {/*  Search */}
            <Stack sx={{ flexBasis: { xs: "100%", sm: "50%", md: "35%" } }}>
              <TextField
                fullWidth
                size="small"
                placeholder="Search by candidate, company, order type..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                sx={{
                  minWidth: 220,
                  "& .MuiOutlinedInput-root": {
                    height: 38,
                    borderRadius: 2,
                    "& fieldset": { borderColor: "rgba(45,109,150,0.35)" },
                    "&:hover fieldset": { borderColor: "#2d6d96" },
                    "&.Mui-focused fieldset": {
                      borderColor: "#2d6d96",
                      borderWidth: 1.5,
                    },
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IoSearch size={18} color="#2d6d96" />
                    </InputAdornment>
                  ),
                }}
              />
            </Stack>
          </Stack>
        </Stack>

        {/* Table */}
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ whiteSpace: "nowrap" }}>
                {[
                  "Buyer Company",
                  "Supplier Company",
                  "Start Date",
                  "Candidate Name",
                  "Order Type",
                  "Acceptance Status",
                  "Action",
                ].map((head) => (
                  <TableCell key={head} sx={{ fontWeight: 600 }}>
                    {head}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {loader ? (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <CircularProgress size={26} />
                  </TableCell>
                </TableRow>
              ) : purchase_details?.length ? (
                purchase_details.map((item, i) => {
                  const isSameCandidate =
                    item.candidateEmpId === lastCandidateId;
                  if (!isSameCandidate) colorToggle = !colorToggle;
                  lastCandidateId = item?.candidateEmpId;
                  const statusIconMap = {
                    ACCEPTED: <Verified sx={{ fontSize: 14 }} />,
                    REJECTED: <BsXCircleFill size={14} />,
                    PENDING: <AiOutlineClockCircle size={14} />,
                    REQUEST_TO_CHANGE: <MdOutlineEditNote size={14} />,
                  };
                  const statusColorMap = {
                    ACCEPTED: "success",
                    REJECTED: "error",
                    PENDING: "warning",
                    REQUEST_TO_CHANGE: "info",
                  };

                  const statusColor =
                    statusColorMap[item.purchaseOrderAcceptanceStatus] ||
                    "default";

                  return (
                    <TableRow
                      key={i}
                      sx={{
                        bgcolor: colorToggle
                          ? "rgba(237,237,237,0.45)"
                          : "#fff",
                      }}
                    >
                      <TableCell>{item.interviewerCompanyName}</TableCell>
                      <TableCell>
                        {item.candidateVendorCompany || "Individual"}
                      </TableCell>
                      <TableCell>{item.startDate}</TableCell>
                      <TableCell>{item.candidateName}</TableCell>
                      <TableCell>
                        <Chip
                          size="small"
                          variant="outlined"
                          sx={{
                            fontSize: 12.5,
                            fontWeight: 500,
                            height: 26,
                            borderRadius: "8px",
                            px: 0.75,
                            borderColor:
                              item.purchaseOrderType === "SUPPLIER_ORDER"
                                ? "#2563eb"
                                : "#16a34a",
                            color:
                              item.purchaseOrderType === "SUPPLIER_ORDER"
                                ? "#2563eb"
                                : "#16a34a",
                            textTransform: "capitalize",
                          }}
                          label={item.purchaseOrderType
                            ?.replaceAll("_", " ")
                            .toLowerCase()}
                        />
                      </TableCell>

                      <TableCell>
                        <Chip
                          size="small"
                          variant="outlined"
                          color={statusColor}
                          icon={
                            statusIconMap[item.purchaseOrderAcceptanceStatus]
                          }
                          label={item.purchaseOrderAcceptanceStatus
                            ?.replaceAll("_", " ")
                            .toLowerCase()}
                          sx={{
                            fontSize: 12.5,
                            fontWeight: 500,
                            height: 26,
                            borderRadius: "8px",
                            px: 0.75,
                            textTransform: "capitalize",
                          }}
                        />
                      </TableCell>

                      <TableCell>
                        <IoEyeSharp
                          style={{
                            fontSize: 18,
                            color: "#286a94",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            navigate(
                              `/admin/purchase_order/detail?candidateId=${item.candidateId}&vendorId=${item.interviewerVendorId}&purchaseId=${item.purchaseOrderId}&interviewId=${item?.interviewId}`,
                              {
                                state: {
                                  jobId: item?.jobId,
                                  interviewId: item?.interviewId,
                                  interviewerVendorId:
                                    item?.interviewerVendorId,
                                  candidateVendorId: item?.candidateVendorId,
                                },
                              }
                            )
                          }
                        />
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <Typography
                      fontSize={14}
                      fontWeight={600}
                      color="textSecondary"
                    >
                      No records available
                    </Typography>
                    <Typography fontSize={12} color="textSecondary">
                      Try adjusting your filters or search criteria.
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {purchase_details?.length > 0 && (
          <Box sx={{mt:2, display:"flex", justifyContent:"center", flexWrap:"wrap"}}>
            <Pagination
              totalPages={totalPages}
              currentPage={pageNumber}
              onPageChange={(page) => setPageNumber(page)}
            />
          </Box>
        )}
      </Paper>
    </Box>
  );
};

const OrderPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const optionsRef = useRef();
  const [pageNumber, setPageNumber] = useState(0);
  const [showOptionsForId, setShowOptionsForId] = useState(null); // State to track which row's options are shown
  const [search, setSearch] = useState("");
  const [size, setSize] = useState(9);
  const [cancelModal, setCancelModal] = useState(false);
  const [loaderC, setLoaderC] = useState(false);
  const [orderId, setOrderId] = useState();
  const [status, setStatus] = useState("");
  useEffect(() => {
    setPageNumber(0);
  }, [search]);

  useEffect(() => {
    if (!SelectedCandidateData || cancelModal === false) {
      dispatch(
        ViewSelectedCandidateList({
          pageNumber,
          size,
          search,
        })
      );
    }
  }, [dispatch, pageNumber, size, search, cancelModal]);

  const handleChange = () => {
    setLoaderC(true);
    ChangeStatusOfPurchaseOrder(orderId, status)
      .then((res) => {
        // console.log("res data", res);
        setLoaderC(false);
        setCancelModal(false);
      })
      .catch((error) => {
        console.log("error data", error);
        setLoaderC(false);
      });
  };

  const handlePageChange = (page) => {
    setPageNumber(page);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (optionsRef.current && !optionsRef.current.contains(event.target)) {
        setShowOptionsForId(null); // Close options menu if clicked outside
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const loader = useSelector((state) => state?.VendorSideDashboard?.loading);
  const totalPages = useSelector(
    (state) => state?.VendorSideDashboard?.result?.totalPages
  );
  const SelectedCandidateData = useSelector(
    (state) => state?.VendorSideDashboard?.result?.content
  );
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (loader) {
    return (
      <Box
        sx={{
          minHeight: "70vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
        }}
      >
        <Loader />

        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            marginTop: 2.5,
            letterSpacing: "0.5px",
          }}
        >
          Loading, please wait…
        </Typography>
      </Box>
    );
  }

  return (
    <div
      style={{
        paddingTop: "20px",
        paddingBottom: "20px",
        backgroundColor: "#f6f9ff",
        minHeight: "100vh",
      }}
    >
      <div style={{ paddingTop: "3px" }}>
        <div
          className="common_wrapper "
          style={{ width: "95%", backgroundColor: "white" }}
        >
          <div
            className="card-header common_table_header"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div style={{ fontSize: width > 500 ? "" : "12px" }}>
              Selected Candidate List
            </div>
            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              <div
                style={{
                  border: "2px solid black",
                  height: "36px",
                  backgroundColor: "white",
                  borderRadius: "0.275rem",
                  display: "flex",
                  border: "1px solid #eee6e4",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: "2rem",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <IoSearch style={{ color: "#286A94", fontSize: "1.25rem" }} />
                </div>
                <input
                  className="small-placeholder"
                  style={{
                    width: "100%",
                    height: "66.67%",
                    margin: "auto 0",
                    paddingLeft: "0.5rem",
                    outline: "none",
                    border: "none",
                  }}
                  placeholder="Search by id,name"
                  type="text"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div
            className="card-body overflow-x-scroll"
            style={{ overflowX: "scroll" }}
          >
            <div className="mt-4" style={{ minWidth: "1150PX" }}>
              <Accordion defaultActiveKey="0">
                {SelectedCandidateData?.length > 0 ? (
                  SelectedCandidateData?.map((job, index) => (
                    <Accordion.Item eventKey={index.toString()} key={job.jobId}>
                      <Accordion.Header>
                        <div
                          style={{
                            display: "flex",
                            width: "100%",
                          }}
                        >
                          {/* First column */}
                          <div style={{ flex: 1, textAlign: "left" }}>
                            Job Id :{" "}
                            <span style={{ fontWeight: 600, color: "black" }}>
                              {job.jobUuid}
                            </span>
                          </div>

                          {/* Second column */}
                          <div style={{ flex: 1, textAlign: "left" }}>
                            Job Name :{" "}
                            <span style={{ fontWeight: 600, color: "black" }}>
                              {job?.jobName || "N/A"}
                            </span>
                          </div>

                          {/* Third column */}
                          <div style={{ flex: 1, textAlign: "right" }}>
                            Selected Candidates :{" "}
                            <span
                              style={{
                                fontWeight: 600,
                                color: "black",
                                marginRight: 6,
                              }}
                            >
                              {job.candidateCount}
                            </span>
                          </div>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body>
                        <Table hover responsive>
                          <thead>
                            <tr>
                              <th>Buyer Company</th>
                              <th>Supplier Company</th>
                              <th>Candidate Name</th>
                              <th>Interview Date</th>
                              <th>Designation</th>
                              <th>PO Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody className="text-start">
                            {loader ? (
                              <tr>
                                <td colSpan="8" className="text-center">
                                  <div style={{ padding: "20px" }}>
                                    <Spinner style={{ color: "#286a94" }} />
                                  </div>
                                </td>
                              </tr>
                            ) : job?.candidates?.length > 0 ? (
                              job?.candidates?.map((item, i) => (
                                <tr key={i}>
                                  <td>{item?.interviewerCompanyName}</td>
                                  <td>
                                    {item?.candidateCompanyName || "Individual"}{" "}
                                  </td>
                                  <td>{item?.candidateName}</td>
                                  <td>{item?.interviewDate?.split(" ")[0]}</td>
                                  <td>{item?.jobPosition}</td>
                                  <td>
                                    <span
                                      style={{
                                        borderRadius: 10,
                                        fontSize: "12px",
                                        fontWeight: 500,
                                        padding: "4px 12px",
                                        color:
                                          item?.PurchaseOrderCreated ===
                                          "Accepted"
                                            ? "#007d3b" // green
                                            : item?.PurchaseOrderCreated ===
                                              "Rejected"
                                            ? "#a50000" // red
                                            : "#996c00", // yellow

                                        backgroundColor:
                                          item?.PurchaseOrderCreated ===
                                          "Accepted"
                                            ? "#cbffe1"
                                            : item?.purchaseOrderCreated ===
                                              "Rejected"
                                            ? "#ffd6d6"
                                            : "#fff5c0",
                                      }}
                                    >
                                      {item?.PurchaseOrderCreated || "N/A"}
                                    </span>
                                  </td>
                                  <td className="d-flex">
                                    <div style={{ paddingLeft: 10 }}>
                                      <IoEyeSharp
                                        onClick={() =>
                                          navigate(
                                            `/admin/selected-candidate/details?candidateId=${item?.candidateId}&vendorId=${item?.interviewerVendorId}&interviewId=${item?.interviewId}`,
                                            {
                                              state: {
                                                jobId: item?.jobId,
                                                interviewId: item?.interviewId,
                                                interviewerVendorId:
                                                  item?.interviewerVendorId,
                                                candidateVendorId:
                                                  item?.candidateVendorId,
                                              },
                                            }
                                          )
                                        }
                                        style={{
                                          fontSize: "18px",
                                          color: "#286a94",
                                          cursor: "pointer",
                                        }}
                                      />
                                    </div>
                                    {item?.PurchaseOrderCreated ===
                                      "Pending" && (
                                      <div style={{ paddingLeft: 10 }}>
                                        <RiExchangeFill
                                          onClick={() => {
                                            setCancelModal(true);
                                            setOrderId(item?.interviewId);
                                            setStatus("On_Hold");
                                          }}
                                          style={{
                                            fontSize: "18px",
                                            color: "#286a94",
                                            cursor: "pointer",
                                          }}
                                        />
                                      </div>
                                    )}
                                    {item?.PurchaseOrderCreated ===
                                      "On_Hold" && (
                                      <div style={{ paddingLeft: 10 }}>
                                        <ImCancelCircle
                                          onClick={() => {
                                            setCancelModal(true);
                                            setOrderId(item?.interviewId);
                                            setStatus("Rejected");
                                          }}
                                          style={{
                                            fontSize: "18px",
                                            color: "#286a94",
                                            cursor: "pointer",
                                          }}
                                        />
                                      </div>
                                    )}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <div className="d-flex align-item-center justify-content-center">
                                No Data Found
                              </div>
                            )}
                          </tbody>
                        </Table>
                      </Accordion.Body>
                    </Accordion.Item>
                  ))
                ) : (
                  <div className="d-flex align-item-center justify-content-center">
                    No Data Found
                  </div>
                )}
              </Accordion>
            </div>
          </div>
          <div>
            {SelectedCandidateData?.length >= 1 ? (
              <Pagination
                totalPages={totalPages}
                currentPage={pageNumber}
                onPageChange={handlePageChange}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <Modal
        show={cancelModal}
        onHide={() => {
          setCancelModal(false);
          setOrderId();
        }}
        backdrop="static"
        keyboard={false}
        style={{ top: "30%" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Change Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Do you want to {status == "Rejected" ? "Reject" : "hold"} this
          candidate?
        </Modal.Body>
        <Modal.Footer
          className="flex-center"
          style={{ justifyContent: "center" }}
        >
          <Button
            className="btn-primary-custom"
            disabled={loaderC}
            onClick={() => handleChange()}
          >
            {loaderC ? "loading..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default OrderPage;
